export const categories = [
  {
    id: 'bebe',
    name: 'Bebê',
    description: 'Conforto e delicadeza para os primeiros anos',
    image: '/img/categories/categ-bebe-v3.jpg',
  },
  {
    id: 'menina',
    name: 'Menina',
    description: 'Estilo e charme para as princesas',
    image: '/img/categories/categ-menina-v3.jpg',
  },
  {
    id: 'menino',
    name: 'Menino',
    description: 'Conforto e modernidade para os pequenos',
    image: '/img/categories/categ-menino-v3.jpg',
  },
  {
    id: 'acessorios',
    name: 'Acessórios',
    description: 'Toques especiais para completar o look',
    image: '/img/categories/categ-acessorios-v3.jpg',
  },
  {
    id: 'lancamentos',
    name: 'Lançamentos',
    description: 'As novidades mais esperadas da temporada',
    image: '/img/categories/categ-lancamentos-v3.jpg',
  },
  {
    id: 'colecoes-especiais',
    name: 'Coleções Especiais',
    description: 'Edições limitadas e exclusivas',
    image: '/img/categories/categ-colecoes-v3.jpg',
  },
];

export const productSizes = ['P', 'M', 'G', 'GG', '1', '2', '3', '4', '6', '8', '10', '12'];

export const productColors = [
  { name: 'Rosa', value: '#F8C8DC' },
  { name: 'Azul', value: '#A7C7E7' },
  { name: 'Verde', value: '#C1E1C1' },
  { name: 'Amarelo', value: '#FDFD96' },
  { name: 'Branco', value: '#FFFFFF' },
  { name: 'Creme', value: '#FFFDD0' },
  { name: 'Laranja', value: '#FFB347' },
  { name: 'Lilás', value: '#C8A2C8' },
];

export const products = [
  // ===== BEBÊ (5) =====
  {
    id: '1',
    name: 'Conjunto Jardineira Bebê',
    category: 'bebe',
    categoryLabel: 'Bebê',
    sizes: ['P', 'M', 'G', '1'],
    colors: ['Verde', 'Creme', 'Branco'],
    description: 'Jardineira fofa em algodão orgânico, com botões de madeira e acabamento delicado. Perfeita para o dia a dia do bebê com muito conforto e estilo. O tecido respirável mantém a pele do bebê sempre sequinha.',
    image: '/img/products/prod-01-v3-img1.jpg',
    images: [
      '/img/products/prod-01-v3-img1.jpg',
      '/img/products/prod-01-v3-img2.jpg',
      '/img/products/prod-01-v3-img3.jpg',
    ],
    price: 79.90,
    isNew: false,
  },
  {
    id: '2',
    name: 'Macacão Bebê Conforto',
    category: 'bebe',
    categoryLabel: 'Bebê',
    sizes: ['P', 'M', 'G', '1'],
    colors: ['Verde', 'Creme', 'Branco', 'Amarelo'],
    description: 'Macacão superconfortável em malha de algodão, com zíper frontal prático. Ideal para trocas rápidas e muito conforto durante o dia todo.',
    image: '/img/products/prod-02-v3-img1.jpg',
    images: [
      '/img/products/prod-02-v3-img1.jpg',
      '/img/products/prod-02-v3-img2.jpg',
      '/img/products/prod-02-v3-img3.jpg',
    ],
    price: 69.90,
    isNew: false,
  },
  {
    id: '3',
    name: 'Body Manga Longa Bebê',
    category: 'bebe',
    categoryLabel: 'Bebê',
    sizes: ['P', 'M', 'G'],
    colors: ['Branco', 'Creme', 'Rosa', 'Azul'],
    description: 'Body essencial em algodão penteado, abertura frontal com botões de pressão. Peça coringa que não pode faltar no guarda-roupa do bebê.',
    image: '/img/products/prod-03-v3-img1.jpg',
    images: [
      '/img/products/prod-03-v3-img1.jpg',
      '/img/products/prod-03-v3-img2.jpg',
      '/img/products/prod-03-v3-img3.jpg',
    ],
    price: 39.90,
    isNew: false,
  },
  {
    id: '4',
    name: 'Casaquinho Bebê Tricô',
    category: 'bebe',
    categoryLabel: 'Bebê',
    sizes: ['P', 'M', 'G'],
    colors: ['Creme', 'Rosa', 'Verde'],
    description: 'Casaquinho artesanal em tricô suave, perfeito para dias fresquinhos. Um charme que aquece com muito amor e delicadeza.',
    image: '/img/products/prod-04-v3-img1.jpg',
    images: [
      '/img/products/prod-04-v3-img1.jpg',
      '/img/products/prod-04-v3-img2.jpg',
      '/img/products/prod-04-v3-img3.jpg',
    ],
    price: 89.90,
    isNew: true,
  },
  {
    id: '5',
    name: 'Kit Calça e Blusa Bebê',
    category: 'bebe',
    categoryLabel: 'Bebê',
    sizes: ['P', 'M', 'G', '1'],
    colors: ['Verde', 'Creme', 'Azul'],
    description: 'Kit completo com blusa e calça coordenadas em moletom macio. Praticidade e estilo para o dia a dia do seu bebê.',
    image: '/img/products/prod-05-v3-img1.jpg',
    images: [
      '/img/products/prod-05-v3-img1.jpg',
      '/img/products/prod-05-v3-img2.jpg',
      '/img/products/prod-05-v3-img3.jpg',
    ],
    price: 99.90,
    isNew: false,
  },

  // ===== MENINA (6) =====
  {
    id: '6',
    name: 'Vestido Floral Infantil',
    category: 'menina',
    categoryLabel: 'Menina',
    sizes: ['P', 'M', 'G', '2', '4', '6'],
    colors: ['Rosa', 'Branco', 'Creme'],
    description: 'Vestido delicado com estampa floral, tecido leve e confortável para o dia a dia. A modelagem rodada permite movimento livre e muita diversão.',
    image: '/img/products/prod-06-v3-img1.jpg',
    images: [
      '/img/products/prod-06-v3-img1.jpg',
      '/img/products/prod-06-v3-img2.jpg',
      '/img/products/prod-06-v3-img3.jpg',
    ],
    price: 89.90,
    isNew: true,
  },
  {
    id: '7',
    name: 'Saia Infantil Charmosa',
    category: 'menina',
    categoryLabel: 'Menina',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Rosa', 'Branco', 'Lilás'],
    description: 'Saia rodada com tule delicado e forro em algodão macio. Perfeita para ocasiões especiais e para o dia a dia com muito charme.',
    image: '/img/products/prod-07-v3-img1.jpg',
    images: [
      '/img/products/prod-07-v3-img1.jpg',
      '/img/products/prod-07-v3-img2.jpg',
      '/img/products/prod-07-v3-img3.jpg',
    ],
    price: 59.90,
    isNew: false,
  },
  {
    id: '8',
    name: 'Blusa Renda Menina',
    category: 'menina',
    categoryLabel: 'Menina',
    sizes: ['P', 'M', 'G', '2', '4', '6'],
    colors: ['Branco', 'Creme', 'Rosa'],
    description: 'Blusa com detalhes em renda na gola, mangas bufantes e tecido leve. Um toque romântico para o look das pequenas.',
    image: '/img/products/prod-08-v3-img1.jpg',
    images: [
      '/img/products/prod-08-v3-img1.jpg',
      '/img/products/prod-08-v3-img2.jpg',
      '/img/products/prod-08-v3-img3.jpg',
    ],
    price: 69.90,
    isNew: false,
  },
  {
    id: '9',
    name: 'Short Saia Infantil',
    category: 'menina',
    categoryLabel: 'Menina',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Lilás', 'Rosa', 'Branco'],
    description: 'Short-saia prático e charmoso, com short interno e saia sobreposta. Liberdade para brincar sem perder o estilo.',
    image: '/img/products/prod-09-v3-img1.jpg',
    images: [
      '/img/products/prod-09-v3-img1.jpg',
      '/img/products/prod-09-v3-img2.jpg',
      '/img/products/prod-09-v3-img3.jpg',
    ],
    price: 54.90,
    isNew: false,
  },
  {
    id: '10',
    name: 'Conjunto Colete e Shorts',
    category: 'menina',
    categoryLabel: 'Menina',
    sizes: ['P', 'M', 'G', '2', '4', '6'],
    colors: ['Rosa', 'Creme', 'Verde'],
    description: 'Conjunto coordenado com colete leve e shorts, ideal para passeios. Looks completos e cheios de estilo para as pequenas.',
    image: '/img/products/prod-10-v3-img1.jpg',
    images: [
      '/img/products/prod-10-v3-img1.jpg',
      '/img/products/prod-10-v3-img2.jpg',
      '/img/products/prod-10-v3-img3.jpg',
    ],
    price: 109.90,
    isNew: true,
  },
  {
    id: '11',
    name: 'Vestido Renda Festa',
    category: 'menina',
    categoryLabel: 'Menina',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Branco', 'Creme', 'Rosa'],
    description: 'Vestido encantador para ocasiões especiais, com camadas de renda e laço na cintura. Um sonho para festas e celebrações.',
    image: '/img/products/prod-11-v3-img1.jpg',
    images: [
      '/img/products/prod-11-v3-img1.jpg',
      '/img/products/prod-11-v3-img2.jpg',
      '/img/products/prod-11-v3-img3.jpg',
    ],
    price: 139.90,
    isNew: false,
  },

  // ===== MENINO (6) =====
  {
    id: '12',
    name: 'Camiseta Infantil Básica',
    category: 'menino',
    categoryLabel: 'Menino',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Azul', 'Verde', 'Branco', 'Amarelo'],
    description: 'Camiseta básica de algodão premium, confortável para o dia a dia. Essencial no guarda-roupa de todo menino.',
    image: '/img/products/prod-12-v3-img1.jpg',
    images: [
      '/img/products/prod-12-v3-img1.jpg',
      '/img/products/prod-12-v3-img2.jpg',
      '/img/products/prod-12-v3-img3.jpg',
    ],
    price: 49.90,
    isNew: false,
  },
  {
    id: '13',
    name: 'Conjunto Menino Casual',
    category: 'menino',
    categoryLabel: 'Menino',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Azul', 'Verde', 'Creme'],
    description: 'Conjunto casual com camiseta e shorts coordenados, perfeito para brincar. Conforto e estilo que acompanham a energia dos pequenos.',
    image: '/img/products/prod-13-v3-img1.jpg',
    images: [
      '/img/products/prod-13-v3-img1.jpg',
      '/img/products/prod-13-v3-img2.jpg',
      '/img/products/prod-13-v3-img3.jpg',
    ],
    price: 99.90,
    isNew: false,
  },
  {
    id: '14',
    name: 'Camisa Polo Infantil',
    category: 'menino',
    categoryLabel: 'Menino',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8', '10'],
    colors: ['Azul', 'Verde', 'Branco', 'Laranja'],
    description: 'Camisa polo clássica em piquet de algodão, gola estruturada e bordado. Elegância casual para qualquer ocasião.',
    image: '/img/products/prod-14-v3-img1.jpg',
    images: [
      '/img/products/prod-14-v3-img1.jpg',
      '/img/products/prod-14-v3-img2.jpg',
      '/img/products/prod-14-v3-img3.jpg',
    ],
    price: 64.90,
    isNew: false,
  },
  {
    id: '15',
    name: 'Bermuda Jeans Infantil',
    category: 'menino',
    categoryLabel: 'Menino',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Azul'],
    description: 'Bermuda jeans com elástico na cintura, confortável e estilosa. Combina com tudo e aguenta a brincadeira.',
    image: '/img/products/prod-15-v3-img1.jpg',
    images: [
      '/img/products/prod-15-v3-img1.jpg',
      '/img/products/prod-15-v3-img2.jpg',
      '/img/products/prod-15-v3-img3.jpg',
    ],
    price: 74.90,
    isNew: false,
  },
  {
    id: '16',
    name: 'Moletom Infantil Capuz',
    category: 'menino',
    categoryLabel: 'Menino',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8', '10'],
    colors: ['Verde', 'Azul', 'Creme'],
    description: 'Moletom com capuz forrado, bolso canguru e acabamento reforçado. Quentinho e estiloso para os dias frios.',
    image: '/img/products/prod-16-v3-img1.jpg',
    images: [
      '/img/products/prod-16-v3-img1.jpg',
      '/img/products/prod-16-v3-img2.jpg',
      '/img/products/prod-16-v3-img3.jpg',
    ],
    price: 119.90,
    isNew: true,
  },
  {
    id: '17',
    name: 'Camisa Xadrez Infantil',
    category: 'menino',
    categoryLabel: 'Menino',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Azul', 'Verde', 'Laranja'],
    description: 'Camisa xadrez em algodão macio, com botões e gola tradicional. Um clássico que nunca sai de moda.',
    image: '/img/products/prod-17-v3-img1.jpg',
    images: [
      '/img/products/prod-17-v3-img1.jpg',
      '/img/products/prod-17-v3-img2.jpg',
      '/img/products/prod-17-v3-img3.jpg',
    ],
    price: 84.90,
    isNew: false,
  },

  // ===== ACESSÓRIOS (5) =====
  {
    id: '18',
    name: 'Laço Infantil Delicado',
    category: 'acessorios',
    categoryLabel: 'Acessórios',
    sizes: ['Único'],
    colors: ['Rosa', 'Branco', 'Lilás', 'Creme'],
    description: 'Laço artesanal em tecido delicado, com presilha antideslizante. O toque final perfeito para qualquer look.',
    image: '/img/products/prod-18-v3-img1.jpg',
    images: [
      '/img/products/prod-18-v3-img1.jpg',
      '/img/products/prod-18-v3-img2.jpg',
      '/img/products/prod-18-v3-img3.jpg',
    ],
    price: 24.90,
    isNew: true,
  },
  {
    id: '19',
    name: 'Faixa de Cabelo Infantil',
    category: 'acessorios',
    categoryLabel: 'Acessórios',
    sizes: ['Único'],
    colors: ['Rosa', 'Branco', 'Creme', 'Lilás'],
    description: 'Faixa elástica revestida com tecido macio e laço lateral. Conforto e charme para o cabelo das pequenas.',
    image: '/img/products/prod-19-v3-img1.jpg',
    images: [
      '/img/products/prod-19-v3-img1.jpg',
      '/img/products/prod-19-v3-img2.jpg',
      '/img/products/prod-19-v3-img3.jpg',
    ],
    price: 19.90,
    isNew: false,
  },
  {
    id: '20',
    name: 'Meia Coleção Infantil',
    category: 'acessorios',
    categoryLabel: 'Acessórios',
    sizes: ['Único', 'P', 'M'],
    colors: ['Branco', 'Rosa', 'Verde', 'Creme'],
    description: 'Kit com 3 pares de meias em algodão com estampas divertidas. Conforto do pezinho com muita fofura.',
    image: '/img/products/prod-20-v3-img1.jpg',
    images: [
      '/img/products/prod-20-v3-img1.jpg',
      '/img/products/prod-20-v3-img2.jpg',
      '/img/products/prod-20-v3-img3.jpg',
    ],
    price: 34.90,
    isNew: false,
  },
  {
    id: '21',
    name: 'Tiara Trançada Infantil',
    category: 'acessorios',
    categoryLabel: 'Acessórios',
    sizes: ['Único'],
    colors: ['Rosa', 'Creme', 'Lilás'],
    description: 'Tiara artesanal com trança de tecido, delicada e confortável. Um charme extra para qualquer penteado.',
    image: '/img/products/prod-21-v3-img1.jpg',
    images: [
      '/img/products/prod-21-v3-img1.jpg',
      '/img/products/prod-21-v3-img2.jpg',
      '/img/products/prod-21-v3-img3.jpg',
    ],
    price: 22.90,
    isNew: false,
  },
  {
    id: '22',
    name: 'Mochila Infantil Leve',
    category: 'acessorios',
    categoryLabel: 'Acessórios',
    sizes: ['Único'],
    colors: ['Rosa', 'Verde', 'Azul'],
    description: 'Mochila compacta e leve com alças acolchoadas, ideal para passeios. Do tamanho certo para as costas dos pequenos.',
    image: '/img/products/prod-22-v3-img1.jpg',
    images: [
      '/img/products/prod-22-v3-img1.jpg',
      '/img/products/prod-22-v3-img2.jpg',
      '/img/products/prod-22-v3-img3.jpg',
    ],
    price: 69.90,
    isNew: true,
  },

  // ===== LANÇAMENTOS (4) =====
  {
    id: '23',
    name: 'Conjunto Verão Infantil',
    category: 'lancamentos',
    categoryLabel: 'Lançamentos',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Amarelo', 'Verde', 'Branco', 'Laranja'],
    description: 'Conjunto leve e refrescante para o verão, tecido respirável e estampas alegres. Pronto para dias de sol e diversão.',
    image: '/img/products/prod-23-v3-img1.jpg',
    images: [
      '/img/products/prod-23-v3-img1.jpg',
      '/img/products/prod-23-v3-img2.jpg',
      '/img/products/prod-23-v3-img3.jpg',
    ],
    price: 109.90,
    isNew: true,
  },
  {
    id: '24',
    name: 'Macacão Jeans Infantil',
    category: 'lancamentos',
    categoryLabel: 'Lançamentos',
    sizes: ['P', 'M', 'G', '2', '4', '6'],
    colors: ['Azul'],
    description: 'Macacão jeans despojado com alças ajustáveis e bolsos frontais. Estilo atemporal que veste do bebê ao infantil.',
    image: '/img/products/prod-24-v3-img1.jpg',
    images: [
      '/img/products/prod-24-v3-img1.jpg',
      '/img/products/prod-24-v3-img2.jpg',
      '/img/products/prod-24-v3-img3.jpg',
    ],
    price: 129.90,
    isNew: true,
  },
  {
    id: '25',
    name: 'Vestido Linho Infantil',
    category: 'lancamentos',
    categoryLabel: 'Lançamentos',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Creme', 'Verde', 'Rosa'],
    description: 'Vestido em linho natural com bordado artesanal na barra, fresquinho e elegante. Perfeito para os dias quentes.',
    image: '/img/products/prod-25-v3-img1.jpg',
    images: [
      '/img/products/prod-25-v3-img1.jpg',
      '/img/products/prod-25-v3-img2.jpg',
      '/img/products/prod-25-v3-img3.jpg',
    ],
    price: 119.90,
    isNew: true,
  },
  {
    id: '26',
    name: 'Blusão Peluciado Infantil',
    category: 'lancamentos',
    categoryLabel: 'Lançamentos',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Creme', 'Rosa', 'Verde'],
    description: 'Blusão quentinho em tecido peluciado, com capuz e bolso frontal. Aconchego puro para os dias mais frios.',
    image: '/img/products/prod-26-v3-img1.jpg',
    images: [
      '/img/products/prod-26-v3-img1.jpg',
      '/img/products/prod-26-v3-img2.jpg',
      '/img/products/prod-26-v3-img3.jpg',
    ],
    price: 99.90,
    isNew: true,
  },

  // ===== CALÇADOS (4) =====
  {
    id: '27',
    name: 'Tênis Infantil Conforto',
    category: 'calcados',
    categoryLabel: 'Calçados',
    sizes: ['2', '3', '4', '6', '8'],
    colors: ['Branco', 'Rosa', 'Verde'],
    description: 'Tênis leve com palmilha acolchoada, fechamento em velcro e solado flexível. Conforto para os primeiros passos.',
    image: '/img/products/prod-27-v3-img1.jpg',
    images: [
      '/img/products/prod-27-v3-img1.jpg',
      '/img/products/prod-27-v3-img2.jpg',
      '/img/products/prod-27-v3-img3.jpg',
    ],
    price: 89.90,
    isNew: false,
  },
  {
    id: '28',
    name: 'Sandália Infantil Charmosa',
    category: 'calcados',
    categoryLabel: 'Calçados',
    sizes: ['2', '3', '4', '6'],
    colors: ['Rosa', 'Creme', 'Branco'],
    description: 'Sandália delicada com tiras em couro macio e fecho ajustável. Elegância e conforto para os pezinhos.',
    image: '/img/products/prod-28-v3-img1.jpg',
    images: [
      '/img/products/prod-28-v3-img1.jpg',
      '/img/products/prod-28-v3-img2.jpg',
      '/img/products/prod-28-v3-img3.jpg',
    ],
    price: 74.90,
    isNew: false,
  },
  {
    id: '29',
    name: 'Botinha Infantil Inverno',
    category: 'calcados',
    categoryLabel: 'Calçados',
    sizes: ['2', '3', '4', '6', '8'],
    colors: ['Creme', 'Rosa', 'Verde'],
    description: 'Botinha forrada com pelinho interno, sola antiderrapante e fecho lateral. Pezinhos quentinhos o inverno todo.',
    image: '/img/products/prod-29-v3-img1.jpg',
    images: [
      '/img/products/prod-29-v3-img1.jpg',
      '/img/products/prod-29-v3-img2.jpg',
      '/img/products/prod-29-v3-img3.jpg',
    ],
    price: 109.90,
    isNew: false,
  },
  {
    id: '30',
    name: 'Chinelo Slide Infantil',
    category: 'calcados',
    categoryLabel: 'Calçados',
    sizes: ['2', '3', '4', '6', '8', '10'],
    colors: ['Verde', 'Rosa', 'Amarelo', 'Branco'],
    description: 'Chinelo slide confortável em EVA macio, ideal para praia e piscina. Secagem rápida e antiderrapante.',
    image: '/img/products/prod-30-v3-img1.jpg',
    images: [
      '/img/products/prod-30-v3-img1.jpg',
      '/img/products/prod-30-v3-img2.jpg',
      '/img/products/prod-30-v3-img3.jpg',
    ],
    price: 39.90,
    isNew: false,
  },

  // ===== PIJAMAS (3) =====
  {
    id: '31',
    name: 'Pijama Conjunto Estampado',
    category: 'pijamas',
    categoryLabel: 'Pijamas',
    sizes: ['P', 'M', 'G', '2', '4', '6'],
    colors: ['Rosa', 'Verde', 'Azul'],
    description: 'Conjunto de pijama em algodão macio com estampa de estrelas e bolinhas. Noites tranquilas e cheias de sonhos.',
    image: '/img/products/prod-31-v3-img1.jpg',
    images: [
      '/img/products/prod-31-v3-img1.jpg',
      '/img/products/prod-31-v3-img2.jpg',
      '/img/products/prod-31-v3-img3.jpg',
    ],
    price: 69.90,
    isNew: false,
  },
  {
    id: '32',
    name: 'Camisola Infantil Delicada',
    category: 'pijamas',
    categoryLabel: 'Pijamas',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Rosa', 'Branco', 'Lilás'],
    description: 'Camisola leve em viscose com renda delicada na barra e mangas curtas. Sonhos doces com muito conforto.',
    image: '/img/products/prod-32-v3-img1.jpg',
    images: [
      '/img/products/prod-32-v3-img1.jpg',
      '/img/products/prod-32-v3-img2.jpg',
      '/img/products/prod-32-v3-img3.jpg',
    ],
    price: 59.90,
    isNew: false,
  },
  {
    id: '33',
    name: 'Roupão Infantil Felpudo',
    category: 'pijamas',
    categoryLabel: 'Pijamas',
    sizes: ['P', 'M', 'G'],
    colors: ['Creme', 'Rosa', 'Verde'],
    description: 'Roupão felpudo com capuz e cinto, ideal para depois do banho. Aconchego e fofura em cada detalhe.',
    image: '/img/products/prod-33-v3-img1.jpg',
    images: [
      '/img/products/prod-33-v3-img1.jpg',
      '/img/products/prod-33-v3-img2.jpg',
      '/img/products/prod-33-v3-img3.jpg',
    ],
    price: 94.90,
    isNew: true,
  },

  // ===== PRAIA E VERÃO (3) =====
  {
    id: '34',
    name: 'Biquíni Infantil Estampado',
    category: 'praia',
    categoryLabel: 'Praia e Verão',
    sizes: ['P', 'M', 'G', '2', '4', '6'],
    colors: ['Rosa', 'Amarelo', 'Verde'],
    description: 'Biquíni de duas peças com proteção UV e estampa tropical divertida. Pronto para dias de sol e mar.',
    image: '/img/products/prod-34-v3-img1.jpg',
    images: [
      '/img/products/prod-34-v3-img1.jpg',
      '/img/products/prod-34-v3-img2.jpg',
      '/img/products/prod-34-v3-img3.jpg',
    ],
    price: 64.90,
    isNew: false,
  },
  {
    id: '35',
    name: 'Sunga Infantil Proteção UV',
    category: 'praia',
    categoryLabel: 'Praia e Verão',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Azul', 'Verde', 'Laranja'],
    description: 'Sunga com proteção UV50+, tecido de secagem rápida e elástico confortável. Proteção e estilo na praia.',
    image: '/img/products/prod-35-v3-img1.jpg',
    images: [
      '/img/products/prod-35-v3-img1.jpg',
      '/img/products/prod-35-v3-img2.jpg',
      '/img/products/prod-35-v3-img3.jpg',
    ],
    price: 49.90,
    isNew: false,
  },
  {
    id: '36',
    name: 'Saída de Praia Infantil',
    category: 'praia',
    categoryLabel: 'Praia e Verão',
    sizes: ['P', 'M', 'G', '2', '4', '6', '8'],
    colors: ['Branco', 'Creme', 'Rosa'],
    description: 'Saída de praia leve em algodão, com capuz e bolso frontal, fácil de vestir. Perfeita para depois do mergulho.',
    image: '/img/products/prod-36-v3-img1.jpg',
    images: [
      '/img/products/prod-36-v3-img1.jpg',
      '/img/products/prod-36-v3-img2.jpg',
      '/img/products/prod-36-v3-img3.jpg',
    ],
    price: 79.90,
    isNew: true,
  },
];

export const collections = [
  {
    id: 'nova-colecao',
    name: 'Nova Coleção',
    description: 'As tendências mais frescas e encantadoras desta temporada para os pequenos.',
    image: '/img/collections/colecao-nova-v3.jpg',
  },
  {
    id: 'looks-dia-a-dia',
    name: 'Looks para o Dia a Dia',
    description: 'Conforto e praticidade para acompanhar cada momento do dia das crianças.',
    image: '/img/collections/colecao-dia-v3.jpg',
  },
  {
    id: 'ocasioes-especiais',
    name: 'Ocasiões Especiais',
    description: 'Peças elegantes e sofisticadas para festas, celebrações e momentos inesquecíveis.',
    image: '/img/collections/colecao-ocasiao-v3.jpg',
  },
  {
    id: 'acessorios-infantis',
    name: 'Acessórios Infantis',
    description: 'Laços, faixas, meias e tudo para complementar com charme o look dos pequenos.',
    image: '/img/collections/colecao-acessorios-v3.jpg',
  },
];

export const testimonials = [
  {
    id: '1',
    name: 'Ana Paula',
    role: 'Mãe de 2',
    text: 'A Maçã Verde transformou a forma como eu escolho roupas para meus filhos. A qualidade é impecável e o atendimento é super atencioso.',
    image: '/img/testimonials/testimonial-ana-v3.jpg',
  },
  {
    id: '2',
    name: 'Mariana',
    role: 'Mãe de 1',
    text: 'Sempre que preciso de algo especial para minha filha, venho aqui. As coleções são lindas, o tecido é super macio.',
    image: '/img/testimonials/testimonial-mariana-v3.jpg',
  },
  {
    id: '3',
    name: 'Fernanda',
    role: 'Mãe de 3',
    text: 'Finalmente encontrei uma marca que entende que crianças precisam de conforto sem abrir mão do estilo. Adoramos!',
    image: '/img/testimonials/testimonial-fernanda-v3.jpg',
  },
];

export const brandValues = [
  {
    id: 'conforto',
    title: 'Conforto',
    description: 'Tecidos selecionados que respeitam a pele delicada das crianças.',
    icon: 'ri-heart-pulse-line',
  },
  {
    id: 'qualidade',
    title: 'Qualidade',
    description: 'Materiais premium e acabamento impecável em cada peça.',
    icon: 'ri-shield-star-line',
  },
  {
    id: 'estilo',
    title: 'Estilo Infantil',
    description: 'Design moderno e delicado que acompanha as tendências.',
    icon: 'ri-sparkling-2-line',
  },
];